"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAll = getAll;
exports.getById = getById;
exports.getDefault = getDefault;
exports.update = update;
exports.insert = insert;
exports.deleteById = deleteById;
exports.bulkDelete = bulkDelete;
exports.getMaxSort = getMaxSort;

var _request = _interopRequireDefault(require("@/helpers/request"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getAll() {
  return (0, _request.default)({
    url: '/type_vente',
    method: 'get'
  });
}

function getById(id) {
  return (0, _request.default)({
    url: '/type_vente/' + id,
    method: 'get'
  });
}

function getDefault() {
  return (0, _request.default)({
    url: '/type_vente/default',
    method: 'get'
  });
}

function update(id, data) {
  return (0, _request.default)({
    url: '/type_vente/' + id,
    method: 'put',
    data: data
  });
}

function insert(data) {
  return (0, _request.default)({
    url: '/type_vente',
    method: 'post',
    data: data
  });
}

function deleteById(id) {
  return (0, _request.default)({
    url: '/type_vente/' + id,
    method: 'delete'
  });
}

function bulkDelete(ids) {
  return (0, _request.default)({
    url: '/type_vente/' + ids,
    method: 'delete'
  });
}

function getMaxSort() {
  return (0, _request.default)({
    url: '/type_vente/max-sort',
    method: 'get'
  });
}